import $ from "jquery";

// import hotClass from "./hotClass";

// console.log("module.id", sourceModule.id);
// console.log("module", sourceModule);
// // Webpack way
// if (sourceModule.hot.addStatusHandler) {
//   console.log("module.hot.addStatusHandler");
//   if (sourceModule.hot.status() === "idle") {
//     console.log("module.hot.addStatusHandler - idle");
//     sourceModule.hot.addStatusHandler(status => {
//       if (status === "apply") {
//         console.log("module.hot.addStatusHandler - apply");
//         try {
//           requireIndirect(sourceModule.id);
//         } catch (e) {
//           console.error("React-Hot-Loader: error detected while loading", sourceModule.id);
//           console.error(e);
//         }
//         this.componentWillUnmount();
//         this.componentWillMount();
//
//         module.instances.forEach(inst => inst.forceUpdate());
//       }
//     });
//   }
// }

import "./Menu.scss";

class MobileMenu {
  constructor() {
    this.componentWillMount();
    this.language = document
      .getElementsByTagName("html")[0]
      .getAttribute("lang")
      .replace(/.*x-mtfrom-(.*)/, "$1");
  }

  componentWillMount() {
    const $menu = $("#menu");
    if (!$menu.hasClass("with-mobile-footer")) {
      const $footerMenu = $(".footer__menu");

      const $vcard = $footerMenu.find(".oldVcard").clone();

      $menu.append(
        $('<li class="footer-item menu-account-item"></li>').append(
          $vcard
            .find(".sitecontrols__link")
            .detach()
            .addClass("link")
            .removeClass("sitecontrols__link")
        )
      );

      $vcard.find("br").remove();

      $menu.append($('<li class="footer-item"></li>').append($vcard));

      $menu.addClass("with-mobile-footer").append(
        $footerMenu
          .find(".menu > li")
          .clone()
          .addClass("footer-item")
          .addClass("footer-menu-item")
      );
      $menu.find("li > a").addClass("link");
    }

    document.querySelector(".mobile-menu-control").addEventListener("click", this.onClickToggleMobileMenu);
    document.addEventListener("click", this.onClickMobileMenu);
    const menuItems = document.querySelectorAll("#menu a, #menu subMenuItem");
    for (const menuItem of menuItems) {
      menuItem.addEventListener("click", this.onClickMobileMenuItem);
    }
    document.addEventListener("swipe", this.onSwipeMobileMenu);
  }

  componentWillUnmount() {
    document.querySelector(".mobile-menu-control").removeEventListener("click", this.onClickToggleMobileMenu);
    document.removeEventListener("click", this.onClickMobileMenu);
    const menuItems = document.querySelectorAll("#menu a, #menu subMenuItem");
    for (const menuItem of menuItems) {
      menuItem.removeEventListener("click", this.onClickMobileMenuItem);
    }
    document.removeEventListener("swipe", this.onSwipeMobileMenu);

    $(".subMenuItem").remove();
    $(".footer-item").remove();
    $("#menu")
      .removeClass("with-mobile-footer")
      .removeClass("fixed-heights");
  }

  onClickToggleMobileMenu = e => {
    // console.log("onClickToggleMobileMenu", this);
    const $menu = $("#menu");
    if (!$menu.hasClass("fixed-heights")) {
      const height = $menu[0].scrollHeight;
      $menu
        .addClass("fixed-heights")
        .find("li > ul")
        .height(height);
    }

    $("html").toggleClass("no-overflow-y");
    $("body").toggleClass("is-mobile-menu");

    $("#menu")
      .find("ul.active")
      .removeClass("active");

    e.stopPropagation();
    return false;
  };

  isActive = () => {
    return $("body").hasClass("is-mobile");
  };

  isOpen = () => {
    return $("body").hasClass("is-mobile-menu");
  };

  onClickMobileMenu = e => {
    const $el = $(e.target);
    if ($el.is("#menu") || $el.closest("#menu").length > 0) {
      return false;
    }
    if (this.isOpen()) {
      $("html").toggleClass("no-overflow-y");
      $("body").toggleClass("is-mobile-menu");
    }
  };

  onSwipeMobileMenu = e => {
    const $el = $(e.target);
    const $ul = $el.closest("ul");
    if (e.direction === "right") {
      $ul.removeClass("active");
    }
  };

  onClickMobileMenuItem = e => {
    const $el = $(e.target);
    const $link = $el.closest("a");

    if (!this.isOpen()) {
      // https://trello.com/c/xcIn4OEt/136-gelegenheid-en-meer-niet-doorklikbaar
      // $('.link[data-id="19760972"],.link[data-id="17706363"]').on("click", e => false);
      if ($link.data("id") === 19760972 || $link.data("id") === 17706363) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return;
    }
    if ($el.hasClass("subMenuBack")) {
      $el.closest("ul").removeClass("active");
      e.preventDefault();
      return false;
    }
    const $sub = $el.closest("li").find(">ul");
    $el
      .closest("ul")
      .find("ul.active")
      .removeClass("active");
    if ($sub.length) {
      if (!$sub.find(".subMenuItem").length) {
        const title = $link.find(".title").text() || $link.text();
        const url = $link.attr("href");
        $sub.prepend(
          $(`
          <li class="subMenuItem subMenuBack" role="button" aria-label="Terug">${
            this.language === "nl" ? "Terug" : "Back"
          }</li>
          <li class="subMenuItem subMenuTitle">
            <a href="${url}" class="subMenuLink">
              ${title}
              ${
                url !== "#"
                  ? `<div>${
                      this.language === "nl" ? "Alles in" : "Everything in"
                    } ${title} <i class="fa fa-chevron-right"></i></div>`
                  : ""
              }
            </a>
          </li>
          `)
        );
        $sub.find(".subMenuItem").on("click", this.onClickMobileMenuItem);
      }
      $sub.addClass("active");
      $("#menu").scrollTop(0);
      e.preventDefault();
      return false;
    }
    $("html").toggleClass("no-overflow-y");
    $("body").toggleClass("is-mobile-menu");
  };
}

// export default hotClass(module)(MobileMenu);
export default MobileMenu;
